
import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { InvestmentDetail } from './../investment-detail/investment-detail';

import styles from './order-form.module.scss';
import { useValidation } from '../../../../hooks/use-validation';
import { investorInfoValidator, investorInfoOrderObj } from '../../../../form-control/order-form/order-form-control';
import { getInvestorCategory, getCountries, getIDTypes,
        getTaxStatuses, getSettBankList, getDeliveryModes,
        getPlaceList, getModeOfCollectionOfInterests, getSourcesOfIncome } from '../../../../helpr/orderFormData';
import { FormGroup, DropDown, TextInput, DateInput, RadioButton, CheckBoxes } from '../../../../components/form/form';
import ApplicantNamesInput from './components/applicant-names-field/applicant-names-field';
import { PATTERN_ALPHA_NUMERIC_SPACE } from '../../../../helpr/constants';
import { PATTERN_ALPHA_SPACE } from '../../../../helpr/constants';


const OrderForm = ({session, orderInfo, saveOrderFormState, purchaseAmount, nextStep}) => {
  const orderFormState = useValidation(investorInfoValidator, investorInfoOrderObj(orderInfo), {border: '1px solid red'});
  const { validate, getField, getDropdownProps, getTextFieldProps, getRadioButtonProps, getCheckBoxesProps, forceSetField } = orderFormState;

  const required = (name) => <a>{name}<span className={styles['red']}>*</span></a>;
  const saveFormData = (step) => {
    var { formState, isFormValid } = validate();
    forceSetField('purchaseAmount', purchaseAmount.toString());
    saveOrderFormState(formState);
    if( step ){ nextStep(step); }
    else if ( isFormValid ) { nextStep(step) }
    else {/*Invalid Form State*/}
  }

  return (
    <div className={styles['order-form-component']}>
      <Row>
        <Col sm={12} lg={8}>
          <FormGroup header={'INVESTOR INFORMATION'}>
            <Row>
              <Col md="6">
                <DropDown inputProps={getDropdownProps('investorCategory')} values={getInvestorCategory()}>
                  { required('INVESTOR CATEGORY:') }
                </DropDown>
              </Col>
            </Row>
            <Row>
              <ApplicantNamesInput investorEmail={session.investorEmail} orderFormState={orderFormState}/>
            </Row>
            <Row>
              <Col className={styles['multi-fields']}>
                <div className={styles['field']}>
                  <div className={styles['field-label']}>
                    PRIMARY CONTACT PERSON
                    <div className={styles['remarks']}>
                      <i>(If other than Applicant)</i>
                    </div>
                  </div>
                </div>
                <div>
                  <Row className={styles['field-input']}>
                    <Col p="0" className={styles['field-input-split']}>
                      <Col md="4" className={styles['lastname']}>
                        <TextInput inputProps={getTextFieldProps('primaryContactLastname')} placeholder="Last Name" maxLength="150" pattern={PATTERN_ALPHA_SPACE}/>
                      </Col>
                      <Col md="4" className={styles['firstname']}>
                        <TextInput inputProps={getTextFieldProps('primaryContactFirstname')} placeholder="First Name" maxLength="150" pattern={PATTERN_ALPHA_SPACE}/>
                      </Col>
                      <Col md="4" className={styles['middlename']}>
                        <TextInput inputProps={getTextFieldProps('primaryContactMiddlename')} placeholder="Middle Name" maxLength="150" pattern={PATTERN_ALPHA_SPACE}/>
                      </Col>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('primaryContactRelation')}>
                  RELATIONSHIP OF PRIMARY CONTACT PERSON TO APPLICANT:
                </TextInput>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col md="6">
                <DropDown inputProps={getDropdownProps('nationality')} values={getCountries()}>
                  { required('NATIONALITY:') }
                </DropDown>
              </Col>
            </Row>
            <Row>
              { getField('investorCategory') !== 'INDV' && <Col>
                <DateInput inputProps={getTextFieldProps('dateOfBirthOrIncorporation')}>
                  { required('DATE OF ' + (getField('investorCategory').includes('INDV')? 'BIRTH' : 'INCORPORATION') + ':') }
                </DateInput>
              </Col> }
              <Col>
                <TextInput inputProps={getTextFieldProps('placeOfBirthOrIncorporation')}>
                  { required('PLACE OF ' + (getField('investorCategory').includes('INDV')? 'BIRTH' : 'INCORPORATION') + ':') }
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <DropDown inputProps={getDropdownProps('idType')} values={getIDTypes(getField('investorCategory'))}>
                  { required('ID Type:') }
                </DropDown>
              </Col>
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('idNumber')} placeholder={"XXXX"} maxLength="30">
                  { required('ID NUMBER:') }
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <DropDown inputProps={getDropdownProps('taxStatus')} values={getTaxStatuses()}>
                  { required('TAX STATUS:') }
                </DropDown>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup header={ (getField('investorCategory').includes('INDV') ? 'WORK' : 'BUSINESS') + ' DETAILS' }>
            <Row>
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('parentCompany')} maxLength="150">
                  Parent Company:
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('natureOfWorkOrPrincipalBusiness')}>
                  { required( (getField('investorCategory').includes('INDV')? 'NATURE OF WORK OR BUSINESS' : ' PRINCIPAL BUSINESS OF THE CORPORATION') + ':' ) }
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('nameOfEmployerOrBusiness')}>
                  { required( 'NAME OF ' + (getField('investorCategory').includes('INDV')? 'EMPLOYER' : 'BUSINESS') + ':' ) }
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <CheckBoxes inputProps={getCheckBoxesProps('sourcesOfIncome')} values={getSourcesOfIncome()} othersOption={true} othersText="Please specify" maxLength="150">
                  { required( 'SOURCES OF INCOME:' ) }
                </CheckBoxes>
              </Col>
            </Row>
          </FormGroup>
        </Col>
        <Col>
          <InvestmentDetail
            issuer={session['securityIssuer']}
            issue={session['securityName']}
            issueLogo={session.securityLogoSrc}
            offerPeriod={session['securityOfferDate']}
            purchaseAmount={purchaseAmount}
            currencyType={session['currency']}
          />
        </Col>
      </Row>
      <Row className={styles['btn-actions']}>
        <Button className="btn-secondary" onClick={()=>saveFormData(true)}>BACK</Button>
        <Button onClick={()=>{saveFormData(false)}}>NEXT</Button>
      </Row>
    </div>
  )
}

export default OrderForm;


